import Vue from 'vue';
import Component from 'vue-class-component';

Component.registerHooks([
    'beforeRouteEnter',
    'beforeRouteLeave',
    'beforeRouteUpdate',
]);
import Router from 'vue-router';

import pages from '@/router/pages';
import entities from '@/router/entities';

Vue.use(Router);

const router = new Router({
    mode: 'history',
    routes: [
        ...pages,
        ...entities,
    ]
});

export default router;
